var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"600px","margin":"0 auto"}},[_c('h1',[_vm._v("Admin System Logs")]),_c('h2',[_vm._v("placeholder")])])
}]

export { render, staticRenderFns }